import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { DateRangePicker as BaseDateRangePicker, defaultStaticRanges } from 'react-date-range'

import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

import ro from 'react-date-range/dist/locale/ro'
import en from 'react-date-range/dist/locale/en-US'

import { map, get, head, values } from 'lodash'

import { translate } from 'parking-react-common'

import { preferences } from '../redux'

import './DateRangePicker.css'

const LOCALES = { en, ro }

const INITIAL_RANGE = {
    startDate : new Date(),
    endDate   : new Date()
}

const DateRangePicker = ({ name, value, locale, t, ...otherProps }) => {
    const staticRanges = map(defaultStaticRanges, (range) => ({
        ...range,
        label: t(range.label)
    }))

    return (
        <BaseDateRangePicker
            locale={ locale }
            ranges={ [value || INITIAL_RANGE] }
            inputRanges={ [] }
            staticRanges={ staticRanges }
            rangeColors={ ['#4285f4'] }
            showPreview={ false }
            showDateDisplay={ false }
            { ...otherProps }
        />
    )
}

DateRangePicker.propTypes = {
    name   : PropTypes.string,
    value  : PropTypes.object,
    locale : PropTypes.object
}

function mapStateToProps(state) {
    const language = preferences.getLanguage(state)
    const locale = get(LOCALES, language, head(values(LOCALES)))

    return {
        locale
    }
}

export default compose(
    translate(),
    connect(mapStateToProps)
)(DateRangePicker)
